export enum StdTraits {
    THRUST_PRODUCER = "thrust_producer",
    STATUS = "status",
}
